import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  type SimpleChanges,
  OnChanges
} from '@angular/core';
import {
  FlightJourney,
  EnterpriseSearchService,
  ServiceType
} from '@sabstravtech/obtservices/angular';
import moment from 'moment';
import {
  FlightDisplayTypes,
  FlightSearchType,
  FlightTempParams,
  PreferredFlags,
  sanitiseDateTime,
  getTimeDifference,
  dayDifference
} from '@sabstravtech/obtservices/base';

@Component({
  selector: 'app-flight-header',
  templateUrl: './flight-header.component.html',
  styleUrls: ['./flight-header.component.scss'],
  standalone: false
})
export class FlightHeaderComponent implements OnInit, OnChanges {
  @Input() flightJourney: FlightJourney;
  @Input() lastFlightJourney: FlightJourney;
  @Input() allJourneys: FlightJourney[];
  @Input() isReturn = false;
  @Input() source: string;
  @Input() duration: number;
  @Output() displayLegs: EventEmitter<boolean> = new EventEmitter();
  @Input() searchType: any;
  @Input() preferred: number = PreferredFlags.none;
  @Input() preferredMessages: Record<PreferredFlags, string>;
  @Input() preferenceLevel = null;
  @Input() tmcPreferredLogoUrl = null;
  @Input() upsell = false;
  search: FlightTempParams;
  PreferredFlags = PreferredFlags;
  displayType: FlightDisplayTypes;
  public FlightSearchType = FlightSearchType;
  public FlightDisplayTypes = FlightDisplayTypes;
  public logoUrl = '';
  constructor(public searchService: EnterpriseSearchService) {}
  timeDifference = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.flightJourney) {
      this.getLogo(changes.flightJourney.currentValue);
    }
  }

  ngOnInit(): void {
    this.search = this.searchService.searches[ServiceType.Flight].originalUserSearch;
    this.displayType = this.searchService.searches[ServiceType.Flight].choosenDisplayType.value;
    if (this.flightJourney) {
      this.getLogo(this.flightJourney);
      this.flightJourney.dateTimeDeparting = sanitiseDateTime(this.flightJourney.dateTimeDeparting);
      if (this.lastFlightJourney) {
        this.lastFlightJourney.dateTimeArriving = sanitiseDateTime(
          this.lastFlightJourney?.dateTimeArriving
        );
      }
    }
  }

  showTimeDifference(arrDateTime: string, depDateTime: string): boolean {
    this.timeDifference = getTimeDifference(arrDateTime, depDateTime);
    return this.searchType === FlightSearchType.multiCity ? !!(this.timeDifference < 1440) : true;
  }

  getLogo(flightJourney) {
    this.logoUrl =
      'https://images.sabscorp.com/images/TourOp/svg/' + flightJourney?.marketingCarrier + '.svg';
  }

  parseDateToMoment(dateString: string): moment.Moment {
    return moment(sanitiseDateTime(dateString));
  }

  calculateDayDifference(dept: string, arr: string): string {
    const diff = dayDifference(sanitiseDateTime(dept), sanitiseDateTime(arr));
    return diff ? '+' + diff : '';
  }

  getNumberOfStops(): number {
    const journeyCount = this.allJourneys?.length ?? 0;
    const destinationCount = this.search?.multiDestination?.length ?? 0;

    if (
      this.searchType === FlightSearchType.multiCity &&
      this.displayType === FlightDisplayTypes.byPrice
    ) {
      return Math.max(journeyCount - destinationCount, 0);
    }

    return Math.max(journeyCount - 1, 0);
  }

  shouldShowPlural(): boolean {
    return this.getNumberOfStops() > 1;
  }
}
